module.exports = __webpack_public_path__ + "static/img/jygl617.2e06b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jygl617.png
// module id = nIZH
// module chunks = 73